{
  "removeButtonLabel": "移除",
  "removeDescription": "按 Delete 鍵以移除標記。"
}
